// Data models for the Cases feature.
// Maps to: GET /v1/analytics/administrative/ticket({orgId})/

export interface Ticket {
  id: number;
  request_id: string;
  created_time: string;
  ticket_status: string;
  subject: string;
  priority: string;
  sla_violation_type: string;
  ticket_closed_time: string | null;
  customer_response_time: string | null;
  ticket_source: string;
  customer_defined_status: string | null;
  description: string;
  issue_type: string;
  source_ip_address_hostname_mac: string | null;
  destination_ip_address_hostname_mac: string | null;
  available_actions?: ResponseActionDefinition[];
}

export interface TicketApiResponse {
  '@odata.count': number;
  value: Ticket[];
}

export interface FilterOption {
  label: string;
  value: string | null;
}

// Description parser models

export interface DescriptionSection {
  title: string;
  content: string;
  keyValues: { key: string; value: string }[];
  actionItems: { text: string; status: string | null }[];
}

export interface ParsedDescription {
  summary: string;
  sections: DescriptionSection[];
}

// Parsed SOC response action (extracted from description text)

export interface SocAction {
  label: string;
  /**
   * True when `label` came from a recognised action phrase rather than from
   * truncating the source text. Section prose scores false here, which is how
   * it is kept out of the action list.
   */
  matchedLabel: boolean;
  status: 'taken' | 'not_taken' | 'not_configured' | 'unknown';
  statusText: string;
  hostname: string | null;
  rawText: string;
}

// Automated response action definition (comes with case data)

export interface ResponseActionDefinition {
  id: string;
  action_type: string;
  name: string;
  description: string;
  confirmation_message: string;
  parameters: Record<string, string>;
}

// Execution state overlay (tracked client-side per action)

export type ActionExecutionStatus = 'idle' | 'confirming' | 'pending' | 'completed' | 'failed' | 'soc_requested';

export interface ActionExecutionState {
  status: ActionExecutionStatus;
  error?: string;
}

// Enriched action for rendering (parsed SocAction + availability + execution state)

export interface EnrichedSocAction extends SocAction {
  actionType: string | null;
  availableAction: ResponseActionDefinition | null;
  executionState: ActionExecutionState;
}

// Filter presets

export const PRIORITY_FILTERS: FilterOption[] = [
  { label: 'All', value: null },
  { label: 'Critical', value: 'Critical' },
  { label: 'High', value: 'High' },
  { label: 'Medium', value: 'Medium' },
  { label: 'Low', value: 'Low' },
];

export const STATUS_FILTERS: FilterOption[] = [
  { label: 'All', value: null },
  { label: 'Open', value: 'open' },
  { label: 'Closed', value: 'closed' },
  { label: 'Needs Response', value: 'awaiting_client' },
];
